import type { PuzzleResult } from './PuzzleGenerator';

export function generatePatternGrid(complexity: number, subtlety: number): PuzzleResult {
  const size = Math.min(2 + Math.floor(complexity / 2), 4); // 2x2 to 4x4 grid
  const colorCount = Math.min(3 + Math.floor(subtlety * 3), 6);

  // Generate a reference grid
  const reference: number[][] = [];
  for (let row = 0; row < size; row++) {
    const r: number[] = [];
    for (let col = 0; col < size; col++) {
      r.push(Math.floor(Math.random() * colorCount));
    }
    reference.push(r);
  }

  const hasError = Math.random() < 0.75;

  let output: number[][];
  if (hasError) {
    output = reference.map(r => [...r]);
    // Pick a random cell to mutate
    const mutRow = Math.floor(Math.random() * size);
    const mutCol = Math.floor(Math.random() * size);
    const original = output[mutRow][mutCol];

    if (subtlety < 0.3) {
      // Easy: change to a very different color
      let newColor: number;
      do {
        newColor = Math.floor(Math.random() * colorCount);
      } while (newColor === original);
      output[mutRow][mutCol] = newColor;
    } else if (subtlety < 0.7) {
      // Medium: change to adjacent color
      output[mutRow][mutCol] = (original + 1) % colorCount;
    } else {
      // Hard: swap two adjacent cells
      const adjCol = Math.min(mutCol + 1, size - 1);
      if (adjCol !== mutCol) {
        [output[mutRow][mutCol], output[mutRow][adjCol]] = [output[mutRow][adjCol], output[mutRow][mutCol]];
      } else {
        output[mutRow][mutCol] = (original + 1) % colorCount;
      }
    }
  } else {
    output = reference.map(r => [...r]);
  }

  return {
    reference,
    output,
    hasError,
    referenceLabel: 'Reference Pattern',
    outputLabel: 'Agent Output',
  };
}
